<template>
  <div class="profile-contacts">
    <info-block :title="$t('labels.contacts')"
                marker-color="#6FCF97"
                hidePaddingTop
                >
      <template v-if="address">
        <div class="profile-block__row">
          <div class="profile-block__row-label">{{ $t('labels.address') }}</div>
          <div class="profile-block__row-data">{{address}}</div>
        </div>
      </template>
      <template v-if="hasContacts()">
        <div v-for="(contact, index) in contacts" :key="contact.index" class="profile-block__row">
          <div class="profile-block__row-label">{{contact.type}}</div>
          <div class="profile-block__row-data">{{contact.value}}</div>
        </div>
      </template>
      <template v-if="!address && !hasContacts()">{{ $t('labels.not_specified') }}</template>
    </info-block>
  </div>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'

  export default {
    props: [
      'contacts',
      'date',
      'address'
    ],
    components: {
      infoBlock
    },
    methods: {
      hasContacts () {
        let hasContacts = false;
        if (!this.contacts) {
          return;
        }
        return this.contacts.length;
      },
      getSiteLink (site) {
        let link = site.replace(/(http:\/\/|https:\/\/)/, '')
        return 'http://' + link;
      }
    }
  }
</script>
<style lang="scss">
.profile-contacts {
  &:before {
    background: #6FCF97;
  }
}
</style>